var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgPortfolioChart16X16 = function SvgPortfolioChart16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 26 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.998 12c0-6.615 5.388-12 12.004-12 .437.002.796.36.797.798v10.401h10.402c.44 0 .8.362.8.8v.01C24.908 18.698 19.559 24 13.002 24 6.387 24 .999 18.616.999 12zm11.203 0V1.762C6.847 2.191 2.6 6.535 2.6 12.001c0 5.749 4.652 10.4 10.402 10.4 5.416 0 9.734-4.168 10.232-9.6H13.001a.804.804 0 01-.8-.8zM15.8.353h.007c.065 0 .13.01.192.026 4.162 1.074 7.455 4.336 8.614 8.614a.804.804 0 01-.772 1.01h-8.041a.804.804 0 01-.8-.8v-8.05c0-.439.36-.8.8-.8zM22.488 8.4c-1.094-2.787-3.182-4.859-5.886-5.9v5.9h5.886z",
    fill: "#9CA6AD"
  })));
};

export default SvgPortfolioChart16X16;